/**
 * What TubeTrailMesh and RibbonTrailMesh decode the same way: the sections, their length and the
 * Curve. Each type cites its own setters.
 */
import { isEqualApprox } from '../../../godot/math/math.js';
import { realOr, settableIntOr } from '../../../parser/valueParsers';
import { decodeCurveResource } from '../../curves/curve/decode';
/**
 * A float whose setter returns early for a value `is_equal_approx` to the one it holds, and the
 * mesh holds the default until a setter stores another (`set_radius`, `set_size`).
 */
export function approxDefaultFloatOr(raw, fallback, context) {
    const value = realOr(raw, fallback, context);
    return isEqualApprox(value, fallback) ? fallback : value;
}
/**
 * `set_sections` ERR_FAILs outside 2 to 128 and keeps the default of 5. `set_section_length` is a
 * bare assignment. `label` is the type name, for the warnings.
 */
export function decodeTrailMeshBase(properties, curve, label) {
    return {
        sections: settableIntOr(properties.sections, 5, { min: 2, max: 128 }, `${label} sections`),
        sectionLength: realOr(properties.section_length, 0.2, `${label} section_length`),
        curve: decodeCurveResource(curve),
    };
}
//# sourceMappingURL=trailDecode.js.map